import { BI_SOURCES } from '@wix/wix-vod-constants/bi';
import createBiLogger from './create-bi-logger';
import cookies from 'js-cookie';
import events from './events';
import { getQueryParameters } from '../utils';
import guid from '../utils/guid';
import setVisitorId from './set-visitor-id';

let biInstance;

/**
 * Create instance of web-bi-logger with
 * @returns {*}
 */
export const createInstance = () => {
  if (biInstance) {
    return biInstance;
  }

  const visitorID = cookies.get('visitorId') || guid();

  setVisitorId(visitorID);

  const { videoId, channelId, instanceId, compId, biToken } =
    getQueryParameters();

  biInstance = createBiLogger({
    events,
    defaults: {
      src: BI_SOURCES.VOD_SRC_ID,
      siteUrl: document.referrer || '',
      channelID: channelId,
      videoID: videoId,
      videoInstanceID: instanceId,
      biToken,
      compId,
      visitorID,
      _instanceId: instanceId,
    },
    // Turn off BI sending for development environment
    disableBi: window.__IS_LOCAL__,
    // logBiSend: true
  });

  return biInstance;
};

/**
 * Log bi via web-bi-logger
 * @param eventName
 * @param params
 */
export const logBi = (eventName, params) => {
  biInstance.log(eventName, params);
};

export const setDefaults = (defaults) => {
  biInstance._defaults = { ...biInstance._defaults, ...defaults };
};

/**
 * Method for logging shared events between embed and widget
 * it extends params object with default values
 * @param eventName
 * @param params
 */
export const logSharedBi = (eventName, params) => {
  biInstance.log(eventName, {
    ...params,
    origin: 'embed',
  });
};
